export default __webpack_public_path__ + "static/media/office1-before1-1440w.9791fab8.avif";